export const NON_AFFORDABLE_RELATIONSHIP_IDS = [
  '13ccf8e1-9600-4622-8951-c4f09aa88be5', // Foster child/adult
  '7a1730c0-74f8-4a1c-8324-6b250385eb85', // Live-in caretaker
];
